const buildBindings = (targets = []) => targets.map((target) => ({
  kind: target.kind,
  value: target.value,
  label: target.label || target.value,
}));

export const A4_EDITORIAL_DOC_TYPE_ORDER = [
  'invoice',
  'quotation',
  'delivery_guide',
  'credit_note',
  'receipt',
  'payment_receipt',
];

export const A4_DOC_TYPE_EDITORIAL_PROFILES = {
  invoice: {
    label: 'Factura A4',
    runtimeRouteFamily: 'Vendas → invoice.pdf',
    previewFocus: 'cabeçalho fiscal, cliente, tabela de itens e totais',
    sections: [
      { id: 'header', title: 'Cabeçalho fiscal', description: 'Número, data e identidade do documento.', bindings: buildBindings([{ kind: 'variable', value: 'doc.number' }, { kind: 'variable', value: 'doc.created_at_display' }, { kind: 'variable', value: 'doc.copy_type' }]) },
      { id: 'customer', title: 'Bloco do cliente', description: 'Nome, contacto e NUIT do cliente.', bindings: buildBindings([{ kind: 'variable', value: 'customer.name' }, { kind: 'variable', value: 'customer.nuit' }, { kind: 'variable', value: 'customer.address' }]) },
      { id: 'lines', title: 'Tabela comercial', description: 'Itens / serviços e colunas principais.', bindings: buildBindings([{ kind: 'datasource', value: 'items' }]) },
      { id: 'totals', title: 'Totais e fiscalidade', description: 'Subtotal, IVA e total final.', bindings: buildBindings([{ kind: 'variable', value: 'totals.subtotal' }, { kind: 'variable', value: 'totals.vat_total' }, { kind: 'variable', value: 'totals.total' }]) },
    ],
  },
  quotation: {
    label: 'Cotação A4',
    runtimeRouteFamily: 'Documentos/Serviços → quotation.pdf',
    previewFocus: 'validade, cliente, itens e linhas de aprovação/conversão',
    sections: [
      { id: 'header', title: 'Cabeçalho comercial', description: 'Número, data e validade.', bindings: buildBindings([{ kind: 'variable', value: 'doc.number' }, { kind: 'variable', value: 'doc.valid_until_display' }, { kind: 'variable', value: 'doc.payment_method' }]) },
      { id: 'customer', title: 'Bloco do cliente', description: 'Contexto comercial do destinatário.', bindings: buildBindings([{ kind: 'variable', value: 'customer.name' }, { kind: 'variable', value: 'customer.contact_person' }, { kind: 'variable', value: 'customer.email' }]) },
      { id: 'lines', title: 'Itens cotados', description: 'Tabela de peças, serviços e quantidades.', bindings: buildBindings([{ kind: 'datasource', value: 'items' }]) },
      { id: 'approval', title: 'Aprovação / conversão', description: 'Linhas operacionais de aprovação e conversão.', bindings: buildBindings([{ kind: 'variable', value: 'totals.quotation_number_line' }, { kind: 'variable', value: 'totals.approved_line' }, { kind: 'variable', value: 'totals.conversion_line' }]) },
    ],
  },
  delivery_guide: {
    label: 'Guia de Entrega A4',
    runtimeRouteFamily: 'Vendas/Serviços → delivery-note/final-delivery',
    previewFocus: 'origem/destino, destinatário, itens e bloco de entrega',
    sections: [
      { id: 'header', title: 'Identificação da guia', description: 'Número, data e tipo do documento.', bindings: buildBindings([{ kind: 'variable', value: 'doc.number' }, { kind: 'variable', value: 'doc.created_at_display' }, { kind: 'variable', value: 'doc.copy_type' }]) },
      { id: 'parties', title: 'Origem / destinatário', description: 'Filial emissora e recebedor.', bindings: buildBindings([{ kind: 'variable', value: 'branch.name' }, { kind: 'variable', value: 'customer.name' }, { kind: 'variable', value: 'customer.address' }]) },
      { id: 'lines', title: 'Linhas expedidas', description: 'Tabela de artigos enviados.', bindings: buildBindings([{ kind: 'datasource', value: 'items' }]) },
      { id: 'handover', title: 'Entrega / assinatura', description: 'Linhas de estado, referência ou recepção.', bindings: buildBindings([{ kind: 'variable', value: 'totals.status_line' }, { kind: 'variable', value: 'doc.copy_type' }]) },
    ],
  },
  credit_note: {
    label: 'Nota de Crédito A4',
    runtimeRouteFamily: 'Vendas/Serviços → credit note runtime',
    previewFocus: 'referência ao original, motivo, itens e totais devolvidos',
    sections: [
      { id: 'header', title: 'Cabeçalho da nota', description: 'Número e identidade do documento.', bindings: buildBindings([{ kind: 'variable', value: 'doc.number' }, { kind: 'variable', value: 'doc.created_at_display' }, { kind: 'variable', value: 'doc.copy_type' }]) },
      { id: 'customer', title: 'Cliente / documento original', description: 'Cliente afectado e referência ao documento original.', bindings: buildBindings([{ kind: 'variable', value: 'customer.name' }, { kind: 'variable', value: 'doc.original_document' }, { kind: 'variable', value: 'totals.original_doc_line' }]) },
      { id: 'lines', title: 'Linhas creditadas', description: 'Itens ou serviços creditados.', bindings: buildBindings([{ kind: 'datasource', value: 'items' }]) },
      { id: 'reason', title: 'Motivo / totais', description: 'Motivo da nota e total devolvido.', bindings: buildBindings([{ kind: 'variable', value: 'doc.reason' }, { kind: 'variable', value: 'totals.status_line' }, { kind: 'variable', value: 'totals.total' }]) },
    ],
  },
  receipt: {
    label: 'Recibo A4',
    runtimeRouteFamily: 'Contas a Receber/Serviços → payment-receipt',
    previewFocus: 'recebimentos, referência, saldo anterior e saldo actual',
    sections: [
      { id: 'header', title: 'Cabeçalho de recebimento', description: 'Número, data e tipo do recibo.', bindings: buildBindings([{ kind: 'variable', value: 'doc.number' }, { kind: 'variable', value: 'doc.created_at_display' }, { kind: 'variable', value: 'doc.payment_method' }]) },
      { id: 'payer', title: 'Pagador / referência', description: 'Cliente e referência do pagamento.', bindings: buildBindings([{ kind: 'variable', value: 'customer.name' }, { kind: 'variable', value: 'totals.reference_line' }, { kind: 'variable', value: 'totals.received_line' }]) },
      { id: 'payments', title: 'Pagamentos / linhas', description: 'Tabela e resumo do recebimento.', bindings: buildBindings([{ kind: 'datasource', value: 'payments' }, { kind: 'datasource', value: 'items' }]) },
      { id: 'balances', title: 'Saldos', description: 'Saldo anterior, recebido e saldo actual.', bindings: buildBindings([{ kind: 'variable', value: 'totals.previous_balance_line' }, { kind: 'variable', value: 'totals.balance_line' }, { kind: 'variable', value: 'totals.total_paid' }]) },
    ],
  },
  payment_receipt: {
    label: 'Comprovativo de Pagamento A4',
    runtimeRouteFamily: 'Serviços → payment-receipt',
    previewFocus: 'pagamentos, referência e prova do valor liquidado',
    sections: [
      { id: 'header', title: 'Cabeçalho do comprovativo', description: 'Número, data e copy type.', bindings: buildBindings([{ kind: 'variable', value: 'doc.number' }, { kind: 'variable', value: 'doc.created_at_display' }, { kind: 'variable', value: 'doc.copy_type' }]) },
      { id: 'customer', title: 'Cliente / serviço', description: 'Cliente e referência operacional.', bindings: buildBindings([{ kind: 'variable', value: 'customer.name' }, { kind: 'variable', value: 'service.number' }, { kind: 'variable', value: 'totals.reference_line' }]) },
      { id: 'payments', title: 'Pagamentos', description: 'Tabela de pagamentos e valor liquidado.', bindings: buildBindings([{ kind: 'datasource', value: 'payments' }, { kind: 'variable', value: 'totals.total_paid' }]) },
      { id: 'balances', title: 'Saldo / fecho', description: 'Linhas de saldo e fecho do documento.', bindings: buildBindings([{ kind: 'variable', value: 'totals.balance_line' }, { kind: 'variable', value: 'totals.received_line' }, { kind: 'variable', value: 'totals.previous_balance_line' }]) },
    ],
  },
};

export const isA4EditorialDocType = (docType) => A4_EDITORIAL_DOC_TYPE_ORDER.includes(String(docType || '').toLowerCase());

export const getA4DocTypeEditorialProfile = (docType) => A4_DOC_TYPE_EDITORIAL_PROFILES[String(docType || '').toLowerCase()] || null;

export const analyzeA4EditorialCoverage = (layout, profile) => {
  if (!profile) return null;
  const elements = layout?.elements || [];
  const variables = new Set(elements.filter((item) => item?.variablePath).map((item) => item.variablePath));
  const datasources = new Set(elements.filter((item) => item?.datasource).map((item) => item.datasource));

  const sections = profile.sections.map((section) => {
    const matched = section.bindings.filter((binding) => (
      binding.kind === 'datasource' ? datasources.has(binding.value) : variables.has(binding.value)
    ));
    const missing = section.bindings.filter((binding) => !matched.includes(binding));
    const ratio = section.bindings.length ? matched.length / section.bindings.length : 0;
    const status = ratio >= 0.75 ? 'Coberto' : ratio > 0 ? 'Parcial' : 'A rever';
    return {
      ...section,
      matched,
      missing,
      ratio,
      status,
    };
  });

  return {
    sections,
    coveredSections: sections.filter((item) => item.status === 'Coberto').length,
    partialSections: sections.filter((item) => item.status === 'Parcial').length,
    reviewSections: sections.filter((item) => item.status === 'A rever').length,
  };
};